import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    InputRightElement,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Link,
} from '@chakra-ui/react';

import { useState,} from 'react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useNavigate,useLocation,} from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux';
import { Login } from '../Redux/AuthReducer/action';



function SignIn() {
    
    const [showPassword, setShowPassword] = useState(false);
    
    const [email,setEmail]=useState("")
    const [password,setPassword]=useState("")
    const location=useLocation()
    

    const isAuth=useSelector((store)=>{
        console.log(store)
        return store.authReducer.isAuth
    })
   
    const dispatch=useDispatch()

    const navigate = useNavigate()


    const handleClick=()=>{

        const userLogin={
            email:email,
            password:password,
        }
        console.log("location",location)
        console.log(email,password)
        dispatch(Login(userLogin)).then(()=>{
            navigate(location.state,{replace:true})
        })
    }

   
    return (
        <Box m={"auto"} >

<Flex
            minH={'100vh'}
            align={'center'}
            justify={'center'}
            bg={useColorModeValue('gray.50', 'gray.800')}>
            <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                <Stack align={'center'}>
                    <Heading fontSize={'4xl'} textAlign={'center'} color={isAuth?"green":"red"}>
                       Login
                    </Heading>
                    <Text fontSize={'lg'} color={'gray.600'}>
                        to enjoy all of our cool features ✌️
                    </Text>
                </Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}
                    w={600}>
                    <Stack spacing={4}>
                       
                        <FormControl id="email" isRequired>
                            <FormLabel>Email address</FormLabel>
                            <Input type="email" value={email} onChange={(e)=>setEmail(e.target.value)}/>
                        </FormControl>
                        <FormControl id="password" isRequired>
                            <FormLabel>Password</FormLabel>
                            <InputGroup>
                                <Input value={password} type={showPassword ? 'text' : 'password'}  onChange={(e)=>setPassword(e.target.value)}/>
                                <InputRightElement h={'full'}>
                                    <Button
                                        variant={'ghost'}
                                        onClick={() =>
                                            setShowPassword((showPassword) => !showPassword)
                                           
                                        }>
                                        {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                    </Button>
                                </InputRightElement>
                            </InputGroup>
                        </FormControl>
                        <Stack spacing={10} pt={2}>
                            <Button
                                loadingText="Submitting"
                                size="lg"
                                bg={'blue.400'}
                                color={'white'}
                                _hover={{
                                    bg: 'blue.500',
                                }}
                                onClick={handleClick}
                                >
                                Sign In
                            </Button>
                        </Stack>
                        <Stack pt={6}>
                            <Text align={'center'}>
                                New a user? <Link onClick={() => navigate("/signup")} color={'blue.400'}>Click here</Link>
                            </Text>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>
        </Flex>


        </Box>
        
    );
}

export default SignIn